import React from "react"
import { FaList } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import PrinterTestButton from "./PrinterTestButton"
import PrinterSaveButton from "./PrinterSaveButton"
import classes from "./index.module.scss"
import clsx from "clsx"

const PrinterFooter = props => {
  const {
    forPos,
    form,
    printerCategoryIds,
    editMode,
    setFormErrors,
    setPrinterIndex,
    setOpenSidebar,
    initialFormErrorsState,
    previousPrinterVariables
  } = props

  const [t, i18n] = useTranslation()

  const showTestButton =
    forPos
      ? true
      :
      !!form.printerType &&
      !!form.printerWidth &&
      !!form.printerInterface &&
      (
        !!form.ipAddress ||
        !!form.macAddress ||
        !!form.deviceName
      )

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["row"]}>
      {
        showTestButton &&
        <PrinterTestButton
          form={form}
          printerCategoryIds={printerCategoryIds}
        />
      }

      <PrinterSaveButton
        form={form}
        editMode={editMode}
        setFormErrors={setFormErrors}
        setPrinterIndex={setPrinterIndex}
        printerCategoryIds={printerCategoryIds}
        initialFormErrorsState={initialFormErrorsState}
        previousPrinterVariables={previousPrinterVariables}
      />

      <Button
        color="warning"
        onClick={() => setOpenSidebar(true)}
        className={clsx(
          classes["select-food"],
          isLtr && classes["select-food-ltr"]
        )}
      >
        <FaList
          color="white"
          size={18}
        />
        <span
          className={clsx(
            classes["select-food-text"],
            isLtr && classes["select-food-text-ltr"]
          )}
        >
          {t("دسته_بندی_کالا_ها_را_انتخاب_کنید")}
        </span>
      </Button>
    </div>
  )
}

export default PrinterFooter